'use client';

import dynamic from "next/dynamic";
import PlanSkeleton from "@/components/shared/PlanSkeleton";

const PlanRecommender = dynamic(() => import("@/components/sections/PlanRecommender"), {
  ssr: false,
  loading: () => <PlanSkeleton count={3} className="mt-8" />,
});

const CombinedPlansLegacy = dynamic(() => import("@/components/sections/CombinedPlansLegacy"), {
  ssr: false,
  loading: () => <PlanSkeleton count={3} className="mt-8" />,
});

export default function CombinedPlans() {
  const experiment = process.env.NEXT_PUBLIC_PLAN_SELECTOR_EXPERIMENT || "recommender";
  if (experiment === "legacy") return <CombinedPlansLegacy />;
  return <PlanRecommender />;
}
